export default __webpack_public_path__ + "static/media/contactsPurple.e812446b.svg";